export class BusinessHookModel {
  public data: any = 'preload';
  public mode: string;
  public name: string;
  public sendData: boolean;
  public type: string;
}
